<div class="container">
  <div
    class="title-bar"
    (click)="toggle.emit()">
    <h3>{{ 'main-menu.directs' | translate }}</h3>
    @if (isActive()) {
      <coin-v2-button
        class="details-btn"
        type="secondary"
        icon="chevron_right"
        iconPos="right"
        [text]="'main-menu.show-details' | translate"
        (click)="openDirectsDialog()"></coin-v2-button>
    }
    <div class="icons custom-hide-down"></div>
  </div>
  @if (isActive()) {
    <div class="content">
      @if (lineManagerDirects()?.length || inCompanyManagerDirects()?.length) {
        <mat-tab-group
          [dynamicHeight]="true"
          (keydown.escape)="closeMenu.emit()">
          @if (lineManagerDirects()?.length) {
            <mat-tab [label]="'main-menu.line-manager' | translate">
              <div
                class="directs"
                role="menu"
                coinKeyboardMenuNavigation="[role='menuitem']"
                [navigationRows]="3">
                @for (direct of lineManagerDirects(); track direct.id) {
                  <customer-app-direct-item-overview
                    role="menuitem"
                    [tabIndex]="0"
                    [direct]="direct"></customer-app-direct-item-overview>
                }
              </div>
            </mat-tab>
          }
          @if (inCompanyManagerDirects()?.length) {
            <mat-tab [label]="'main-menu.incompany-manager' | translate">
              <div
                class="directs"
                role="menu"
                coinKeyboardMenuNavigation="[role='menuitem']"
                [navigationRows]="3">
                @for (direct of inCompanyManagerDirects(); track direct.id) {
                  <customer-app-direct-item-overview
                    role="menuitem"
                    [tabIndex]="0"
                    [direct]="direct"></customer-app-direct-item-overview>
                }
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      }
    </div>
  }
</div>
